import { PROCESS_STAGES, ProcessStepper } from "../../process-stepper";

export function HoeWerktHetPage() {
  return (
    <section>
      <div className="page-head">
        <div>
          <h1>Hoe werkt het?</h1>
          <p>
            Het volledige traject van uw aanvraag, van indiening tot advies, stap voor stap
            uitgelegd.
          </p>
        </div>
      </div>

      {/* Overzicht van het volledige traject */}
      <div className="card ua-mb-space">
        <div className="card__head">
          <h2>Het traject in één oogopslag</h2>
        </div>
        <div className="card__body">
          <ProcessStepper />
        </div>
      </div>

      {/* Elke fase toegelicht */}
      <div className="card">
        <div className="card__head">
          <h2>Elke fase toegelicht</h2>
          <span className="ua-muted-sm">Wie doet wat: AI of mens</span>
        </div>
        <div className="card__body">
          <ol className="ua-col-sm-tight">
            {PROCESS_STAGES.map((stage, index) => (
              <li key={stage.id} className="control-item">
                <span
                  className={
                    stage.actor === "ai"
                      ? "control-icon control-icon--ai"
                      : "control-icon control-icon--human"
                  }
                >
                  {stage.actor === "ai" ? "AI" : stage.actor === "system" ? "✓" : "H"}
                </span>
                <div>
                  <div className="ua-bold-sm">
                    {index + 1}. {stage.label}
                  </div>
                  <div className="ua-muted-xs">{stage.detail}</div>
                </div>
              </li>
            ))}
          </ol>
        </div>
      </div>
    </section>
  );
}
